import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../config/api';

const BlingCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processando');
  const [message, setMessage] = useState('Processando autorização...');

  useEffect(() => {
    const processCallback = async () => {
      try {
        // Pegar parâmetros da URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state'); // ID da conta
        const error = urlParams.get('error');

        console.log('🔗 Callback Bling recebido:', { code, state, error });

        if (error) {
          setStatus('erro');
          setMessage(`Erro na autorização: ${error}`);
          return;
        }

        if (!code || !state) {
          setStatus('erro');
          setMessage('Parâmetros de autorização inválidos');
          return;
        }

        setMessage('Trocando código por token...');

        const authToken = localStorage.getItem('token');
        if (!authToken) {
          // Sem token → redirect pra login (SEC-7)
          window.location.href = '/#/login';
          return;
        }

        // Enviar código para o backend trocar por token
        const response = await fetch(`${API_URL}/api/bling/contas/${state}/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
          body: JSON.stringify({ code })
        });

        const result = await response.json();

        if (result.success) {
          setStatus('sucesso');
          setMessage('Conta autorizada com sucesso!');
          
          // Redirecionar para a página de integração após 2 segundos
          setTimeout(() => {
            navigate('/integration/bling');
          }, 2000);
        } else {
          setStatus('erro');
          setMessage(result.message || 'Erro ao processar autorização');
        }

      } catch (error) {
        console.error('❌ Erro no callback:', error);
        setStatus('erro');
        setMessage('Erro interno: ' + error.message);
      }
    };

    processCallback();
  }, [navigate]);

  const getStatusIcon = () => {
    switch (status) {
      case 'processando':
        return 'mdi:loading';
      case 'sucesso':
        return 'mdi:check-circle';
      case 'erro':
        return 'mdi:close-circle';
      default:
        return 'mdi:loading';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'processando':
        return 'text-primary';
      case 'sucesso':
        return 'text-success';
      case 'erro':
        return 'text-danger';
      default:
        return 'text-primary';
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <i 
                  className={`mdi ${getStatusIcon()} ${getStatusColor()}`}
                  style={{ fontSize: '4rem' }}
                ></i>
              </div>
              
              <h4 className="mb-3">Autorização Bling</h4>
              
              <p className="text-muted mb-4">{message}</p>
              
              {status === 'processando' && (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              )}
              
              {status === 'sucesso' && (
                <div className="alert alert-success">
                  <i className="mdi mdi-check-circle me-2"></i>
                  Redirecionando para a página de integração...
                </div>
              )}
              
              {status === 'erro' && (
                <div className="alert alert-danger">
                  <i className="mdi mdi-alert-circle me-2"></i>
                  {message}
                </div>
              )}
              
              <div className="mt-4">
                <button 
                  className="btn btn-primary"
                  onClick={() => navigate('/integration/bling')}
                >
                  <i className="mdi mdi-arrow-left me-2"></i>
                  Voltar para Integrações
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlingCallback;